import useApiData from "../../hooks/useApiData";

const fallbackContact = {
  contact: {},
  social: {},
};

const toWhatsAppLink = (value) => {
  const digits = (value || "").replace(/[^\d]/g, "");
  return digits ? `https://wa.me/${digits}` : "";
};

export default function FloatingWhatsApp() {
  const { data } = useApiData("/contact-info", fallbackContact);
  const whatsappNumber = data?.contact?.whatsapp_number;
  const whatsappLink = toWhatsAppLink(whatsappNumber);

  if (!whatsappLink) return null;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed left-4 bottom-4 z-[9999] w-12 h-12 flex items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg hover:scale-105 transition-transform"
    >
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        aria-hidden="true"
        className="fill-current"
      >
        <path d="M20.52 3.48A11.93 11.93 0 0 0 12 .01C5.37.01.02 5.36.02 11.99c0 2.11.55 4.16 1.6 5.97L0 24l6.2-1.62a11.94 11.94 0 0 0 5.8 1.48h.01c6.63 0 11.98-5.35 11.98-11.98 0-3.2-1.25-6.21-3.47-8.4ZM12.01 21.3h-.01a9.34 9.34 0 0 1-4.76-1.3l-.34-.2-3.68.97.98-3.59-.22-.36a9.31 9.31 0 0 1-1.42-4.94c0-5.16 4.2-9.36 9.37-9.36 2.5 0 4.85.97 6.62 2.74a9.28 9.28 0 0 1 2.74 6.62c0 5.16-4.2 9.36-9.28 9.36Zm5.16-7.05c-.28-.14-1.65-.81-1.9-.9-.26-.09-.45-.14-.64.14-.19.28-.73.9-.9 1.08-.17.19-.33.21-.61.07-1.7-.85-2.82-1.52-3.95-3.45-.3-.52.3-.48.86-1.6.1-.2.05-.37-.02-.52-.07-.14-.64-1.54-.88-2.1-.23-.56-.46-.48-.64-.49-.17-.01-.36-.01-.55-.01-.19 0-.5.07-.76.37-.26.28-1 1-.99 2.44.01 1.44 1.05 2.83 1.2 3.02.14.19 2.07 3.16 5.03 4.43.7.3 1.25.48 1.67.61.7.22 1.33.19 1.83.11.56-.08 1.65-.67 1.89-1.32.24-.64.24-1.2.17-1.32-.06-.12-.26-.19-.54-.33Z" />
      </svg>
    </a>
  );
}
